export { getLabelNameFromHost } from "./get-label-name-from-host";
